import { useEffect, useState } from 'react';
import { useCalibration } from '../../../context/calibrationContext';
import { useReceiveMessage } from '../../../context/messageContext';
import { CardMirrorView } from '../../session/calibration/ClinicianCalibrationViews';
import { useCalibrationSync } from '../../session/calibration/sync';

// Card calibration, clinician side: mirrors the patient's card (cardDimensions -> optician-view
// runs cardDimensionCalculations). Next = confirm, as before.
const CalibrationCard = ({ setStep, postMessage }) => {
  const received = useReceiveMessage();
  const [submitted, setSubmitted] = useState(false);
  const { patchCalibration } = useCalibrationSync();
  const {
    updateCalibrationData,
    calibrationData: { cardDimensions, pixelDensity },
  } = useCalibration();

  useEffect(() => {
    if (received?.type === 'cardDimensions') setSubmitted(received?.content?.initial === false);
  }, [received]);

  return (
    <CardMirrorView
      widthPx={cardDimensions?.widthPx}
      heightPx={cardDimensions?.heightPx}
      received={submitted}
      onBack={() => {
        postMessage({ type: 'screen-calibration' });
        setStep('screen-calibration');
      }}
      onNext={() => {
        updateCalibrationData({ screenCalibrated: true });
        postMessage({ type: 'calibration-selection' });
        patchCalibration({ method: 'card', screen_calibrated: true, card_ratio: pixelDensity || null });
        setStep('calibration-selection');
      }}
    />
  );
};

export default CalibrationCard;
